import { Directive } from '@angular/core';
import {AbstractControl, NG_VALIDATORS} from "@angular/forms";
import {CustomValidationService} from "../services/custom-validation.service";

@Directive({
  selector: '[app-addressNumber]',
  providers: [{ provide: NG_VALIDATORS, useExisting: AddressNumberPatternDirective, multi: true }]
})
export class AddressNumberPatternDirective {

  constructor(private customValidator: CustomValidationService) { }

  validate(control: AbstractControl): { [key: string]: any } | null {
    return this.customValidator.AddressNumberPatternValidator()(control);
  }

}